import { useCurrentEditor } from '@tiptap/react';
import { useEffect, useState } from 'react';

import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';

export function useEditorState() {
  const { editor } = useCurrentEditor();
  const [, forceUpdate] = useState({});
  const update = useDebouncedCallback(() => forceUpdate({}), {
    delay: 100,
    flushOnUnmount: true,
  });

  useEffect(() => {
    if (!editor) return;
    editor.on('transaction', update);
    return () => {
      editor.off('transaction', update);
    };
  }, [editor, update]);

  return editor;
}
